'use client'

import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable, computed } from 'mobx'
import i18n from 'i18next'
// TODO: swap out with direct link to file in ../react-beautiful-dnd.js (find other locations)
import { DragDropContext } from 'react-beautiful-dnd'
import * as R from 'ramda'
import Button from '../../UniformComponents/Button'
import ConfirmationModal from '../../UniformComponents/ConfirmationModal'
import PageList from '../PageList'
import AdminBox from './components/AdminBox'
import ClosedBox from './components/ClosedBox'
import PublishBanner from './components/PublishBanner'
import SurveyOverview from './components/SurveyOverview'
import SkipLogicModal from './Modals/PageSkipLogic'
import QuestionDelete from './Modals/QuestionDelete'
import AddChartModal from './Modals/AddChartModal'
import QuestionDisable from './Modals/QuestionDisable'
import PageDelete from './Modals/PageDelete'
import PageDisable from './Modals/PageDisable'
import MandatoryPopup from './Modals/MandatoryPopup'
import QuestionPipe from './Modals/QuestionPipe'
import GrabIcon from '../../assets/images/move-icon.svg'
import PageQuestionAPI from '../../API/PageQuestion'
import { getParentFromQlist, getAiQuestions } from '../../utils/QuestionHelper'
import {
    CountryListQuestion,
    DropdownListQuestion,
    GridQuestion,
    SmartGridQuestion,
    MultipleChoiceQuestion,
    NumericQuestion,
    PercentageQuestion,
    PriorityQuestion,
    RatingQuestion,
    SingleChoiceQuestion,
    StaticText,
    TextAreaQuestion,
    TextBoxQuestion,
    UrlVariableQuestion,
    TextBoxListQuestion,
    FormQuestion,
    NumberFormQuestion,
    DateQuestion,
    FailedQuestion,
} from '../../Models/Question'
import { reorderPagePageBlockIndex } from '../../utils/helpers'
import Panel from '../../UniformComponents/Panel'
import QuestionBuilder from '../../QuestionBuilder'
import Select from '../form/Select'
import HoverInfo from '../../UniformComponents/HoverInfo'
import QuestionLibrary from '../../QList/QuestionLibrary'
import DownloadModal from '../Modals/DownloadModal'
import SurveyQuotaModal from './Modals/SurveyQuotaModal'
import NewRapidSurveyModal from './Modals/NewRapidSurveyModal'
import PageBlockHide from './Modals/PageBlockHide'
import PageBlockDelete from './Modals/PageBlockDelete'
import PageTemplate from './Modals/PageTemplate'
import PageSkipLogicPreview from './Modals/PageSkipLogicPreview'
import UnsavedSkipLogicModal from './Modals/UnsavedSkipLogicModal'
import InheritanceWarningModal from './Modals/InheritanceWarningModal'
import ExploriEditWarningModal from './Modals/ExploriEditWarningModal'
import AddAiQuestion from './Modals/AddAiQuestion'
import RemoveAiQuestion from './Modals/RemoveAiQuestion'
import { affectedSkipLogicAfterPageQuestionMove } from '../../utils/SurveyChangeWarnings'

import '../../assets/css/publish.css'
import '../../assets/css/surveybuilder.css'
import './builder.scss'
import AppLoading from '../AppLoading'
import CertificationSidebar from '../CertificationSidebar'
import Translate from '../Translate'
import RapidSurveyAccordion from './components/RapidSurveyAccordion'

const MockQuestion = ({ text, color, style }) => (
    <div className="builder-question-mock-content" style={style}>
        <div className="builder-question-mock-content-inner-container">
            <div className="builder-question-mock-content-left-content">
                <HoverInfo
                    cssClass="hover-info"
                    desc="content"
                    dir="right"
                >
                    <i className="info-icon fa-solid fa-circle-question builder-question-mock-info-icon" />
                </HoverInfo>

                <p className="builder-question-mock-question-title" dangerouslySetInnerHTML={{ __html: text }} />
            </div>

            <div className="builder-question-mock-question-separator" />

            <div className="builder-question-mock-question-container">
                <div className="builder-question-mock-question-wrapper">
                    <div className={`builder-question-mock-question-color-tab ${color}`} />

                    <div className="builder-question-mock-question-content">
                        <img src={GrabIcon} alt="Grab icon" />

                        <div className="builder-question-mock-question-chevron">
                            <i className="fas fa-chevron-down" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

@observer
export default class Builder extends Component {
    loadFailed = false

    @observable questionLibraryLoading = true

    @observable surveyLoading = true

    @observable surveyQuotaModalOpen = false

    @observable pageDragId = ''

    @observable surveyContainsParentWithMappings = {
        show: false,
        questionTitle: null,
    }

    @observable missingParentQuestion = { show: false, msg: null }

    @observable showNewRapidSurveyModal = false

    constructor(props) {
        super(props)
        makeObservable(this)
        const { store } = props
        const { survey } = store
        store.surveyLocale = survey.metadata.defaultLocale
        store.WH = window.innerHeight
        PageQuestionAPI.store = store
        PageQuestionAPI.surveyId = survey.id
        window.addEventListener('message', this.iframeMsgListener, false)

        this.questionLibraryLoaded()
        this.setShowNewRapidSurveyModal()
    }

    async componentDidMount() {
        const { store } = this.props
        await getAiQuestions(store)
    }

    componentWillUnmount() {
        const { store } = this.props
        Reflect.deleteProperty(store, 'iframeRefs')
        store.showTranslate = false
        window.removeEventListener('message', this.iframeMsgListener, false)
    }

    @computed get isReady() {
        return (!this.surveyLoading && !this.questionLibraryLoading)
    }

    setShowNewRapidSurveyModal = (show = true) => {
        const { store } = this.props
        const { survey } = store
        const { location, history } = window
        const isNewRapidSurvey = survey.metadata.isRapidSurvey && location.hash === '#new'
        if (!show) {
            history.replaceState(null, '', window.location.pathname)
            this.showNewRapidSurveyModal = false
        } else {
            this.showNewRapidSurveyModal = isNewRapidSurvey
        }
    }

    hideSkipLogicModal = () => {
        const { store } = this.props
        store.skipLogicModalVisible = false
    }

    openDownloadModal = () => {
        const { store } = this.props
        store.downloadModalOpen = true
    }

    openSurveyQuotaModal = () => {
        this.surveyQuotaModalOpen = true
    }

    hideSurveyQuotaModal = () => {
        this.surveyQuotaModalOpen = false
    }

    setQuestionLibraryLoaded = () => {
        this.questionLibraryLoading = false
    }

    iframeMsgListener = (event) => {
        const { store } = this.props
        try {
            const msg = event.data
            if (msg.mode === 'pageQuestionOnly') {
                const iframeRef = store.iframeRefs.get(msg.questionId)
                if (iframeRef && iframeRef.height === 'auto') {
                    store.iframeRefs.set(msg.questionId, {
                        ref: iframeRef.ref,
                        height: msg.height + 1, // +1 so grid questions dont show a scrollbar
                    })
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    scrollOffset = () => {
        const winH = window.innerHeight - (95 + 20 + 20)
        if (this.questionLibraryOffset < window.scrollY && winH > this.questionLibrary.offsetHeight) {
            this.questionLibrary.style['margin-top'] = `${window.scrollY - this.questionLibraryOffset + 30}px`
        } else if (this.questionLibraryOffset > window.scrollY) {
            this.questionLibrary.style['margin-top'] = '0px'
        }
    }

    questionLibraryLoaded = async () => {
        const that = this
        const { store } = this.props
        const { survey } = store
        survey.loadingQuestions = true
        store.toggleAdminBox = false
        if (typeof store.builderOffset === 'number') {
            document.body.scrollTop = store.builderOffset
        }
        console.log('store duper', store.survey.metadata.productInfo.industrySpecificInfo)
        console.log(`Builder componentDidMount ${store.builderOffset}`)
        store.builderOffset = 0

        window.addEventListener('scroll', this.scrollOffset)
        this.html = document.documentElement

        store.http.get(`/qlist/${store.tokenData.clientId}/categories`)
            .then((categories) => {
                survey.questionCategory = categories.find((category) => category.description === 'SURVEY ONLY')
            })

        let questionUrl = `/api/survey/${survey.id}/questions`
        questionUrl += `?portfolioId=${survey.portfolioId}`
        questionUrl += `&surveyType=${survey.metadata.taxonomy.surveyType}`
        questionUrl += `&respondentType=${survey.metadata.taxonomy.respondentType}`
        questionUrl += `&productType=${survey.metadata.productInfo.industrySpecificInfo.productType}`
        questionUrl += `&industry=${survey.metadata.productInfo.industrySpecificInfo.industry}`
        store.http.get(questionUrl)
            .then((questions) => {
                let questionsLoaded = 0
                const pageQuestions = survey.standardPages.reduce((c, st) => {
                    st.questions.forEach((pq) => {
                        c[pq.id] = pq
                    })
                    return c
                }, {})
                const questionCount = survey.standardPages.reduce((c, st) => {
                    c += st.questions.length
                    return c
                }, 0)
                store.failedQuestions = []
                questions.forEach((question) => {
                    if (question.status !== 'failed') {
                        let h = null
                        switch (question.question.questionTypeCode) {
                            case 'CH':
                                h = new MultipleChoiceQuestion(question.question)
                                break
                            case 'CO':
                                h = new CountryListQuestion(question.question)
                                break
                            case 'I':
                                h = new NumericQuestion(question.question)
                                break
                            case 'OD':
                                h = new PriorityQuestion(question.question)
                                break
                            case 'PC':
                                h = new PercentageQuestion(question.question)
                                break
                            case 'RD':
                                h = new SingleChoiceQuestion(question.question)
                                break
                            case 'UV':
                                h = new UrlVariableQuestion(question.question)
                                break
                            case 'TL':
                                h = new TextBoxListQuestion(question.question)
                                break
                            case 'FM':
                                h = new FormQuestion(question.question)
                                break
                            case 'NF':
                                h = new NumberFormQuestion(question.question)
                                break
                            case 'DT':
                                h = new DateQuestion(question.question)
                                break
                            case 'RT':
                                h = new RatingQuestion(question.question)
                                break
                            case 'SB':
                                h = new DropdownListQuestion(question.question)
                                break
                            case 'ST':
                                h = new StaticText(question.question)
                                break
                            case 'TA':
                                h = new TextAreaQuestion(question.question)
                                break
                            case 'TB':
                                h = new GridQuestion(question.question)
                                break
                            case 'SG':
                                h = new SmartGridQuestion(question.question)
                                break
                            case 'TX':
                                h = new TextBoxQuestion(question.question)
                                break
                            default:
                                h = null
                        }
                        const pageQuestion = pageQuestions[Object.keys(pageQuestions).find((pq) => pq.toUpperCase() === question.pageQuestionId.toUpperCase())]
                        if (pageQuestion) {
                            pageQuestion.question = h
                            pageQuestion.isEditable = question.editMode !== 'None'
                            pageQuestion.usedInOtherSurveys = question.usedInOtherSurveys
                            pageQuestion.usedInParentSurvey = question.usedInParentSurvey
                            pageQuestion.modifiable = true
                            pageQuestion.deletable = !question.surveyMandatory
                            // pageQuestion.setDeletable(store)
                            store.missingSmartOptions = store.missingSmartOptions
                                || (pageQuestion.question.questionTypeCode === 'SG'
                                    && (!pageQuestion.question.optionSetX.options.length
                                        || !pageQuestion.question.optionSetY.options.length))
                            questionsLoaded++
                        }
                    } else {
                        store.failedQuestions.push(question.questionId)
                    }

                    // survey.pageQuestions[question.pageQuestionId].populate(question, (q, failed) => {
                    //     questionsLoaded += !failed ? 1 : 0
                    //     if (failed) {
                    //         console.log(`Failed to load pageQuestion ${question.pageQuestionId}`)
                    //     }
                    // })
                })
                console.log('here4')
                console.log({
                    questionsLoaded,
                    questionCount,
                })
                survey.num_questions = questionsLoaded
                const questionIds = new Set(questions.map(({ question }) => question.id))
                store.failedQuestions = new Set()

                survey.pages.forEach((page) => {
                    if (page.questions) {
                        page.questions.forEach((pageQuestion) => {
                            if (!questionIds.has(pageQuestion.questionId.toLowerCase())) {
                                pageQuestion.question = new FailedQuestion()
                                pageQuestion.isEditable = false
                                pageQuestion.usedInOtherSurveys = false
                                pageQuestion.usedInParentSurvey = false
                                pageQuestion.modifiable = false
                                pageQuestion.deletable = false
                                store.failedQuestions.add(pageQuestion.questionId)
                            }
                        })
                    }
                })

                survey.loadingQuestions = false
                console.log(`failed questions ${store.failedQuestions}`)
            })
            .catch((e) => {
                this.loadFailed = true
                store.failedToLoadSurvey = true
                console.error(`Error loading questions ${e}`)
            }).finally(() => {
                this.surveyLoading = false
            })
    }

    gotoSettings = () => {
        const { history, store } = this.props
        history.push(`/survey/${store.survey.id}`)
    }

    addCompletionPage = () => {
        const { store } = this.props
        const { survey } = store
        if (survey.closed) {
            return
        }
        console.log('addCompletionPage')
        survey.addCompletionPage(store)
    }

    addQuotaPage = () => {
        const { store } = this.props
        const { survey } = store
        if (survey.closed) {
            return
        }
        console.log('addQuotaPage')
        survey.addQuotaFullPage(store)
    }

    addScreeningExitPage = () => {
        const { store } = this.props
        const { survey } = store
        if (survey.closed) {
            return
        }
        console.log('addScreeningExitPage')
        survey.addScreeningExitPage(store)
        // survey.addPage("EX", "Screening Exit Page")
    }

    changeLanguage = (langObj) => {
        const { store } = this.props
        const { survey } = store
        console.log('changeLanguage')
        survey.lang = langObj
        store.changeLanguage(langObj)
    }

    notImplemented = () => {
        alert('not implemented')
    }

    changeLanguage = (locale) => {
        const { store } = this.props
        store.surveyLocale = locale.value
    }

    hideRouting = () => {
        const { store } = this.props
        store.showPageRouting = false
        store.quotaRouting = false
    }

    handleDragStart = ({ draggableId }) => {
        const draggableElem = document.querySelector(
            `[data-rbd-drag-handle-draggable-id='${draggableId}']`,
        )
        if (draggableElem) {
            const hasFooter = draggableElem.classList.contains('has-footer')
            draggableElem.dataset.originalInlineHeight = draggableElem.style.height
            draggableElem.style.height = hasFooter ? '90px' : '50px'
        }
        this.pageDragId = draggableId
    }

    onDragEnd = ({ source, destination, draggableId }) => {
        console.log('builder question onDragEnd')
        if (destination.droppableId === 'qList') return
        const { store } = this.props
        const { survey } = store

        this.pageDragId = ''
        const draggableElem = document.querySelector(
            `[data-rbd-drag-handle-draggable-id='${draggableId}']`,
        )
        if (draggableElem) {
            draggableElem.style.height = draggableElem.dataset.originalInlineHeight
            delete draggableElem.dataset.originalInlineHeight
        }
        if (!destination) {
            return
        }

        if (store.dropTargets[destination.droppableId]) {
            const to = store.dropTargets[destination.droppableId]
            const from = store.dropTargets[source.droppableId]
            if (source.droppableId === destination.droppableId && !destination.droppableId.includes('questionList')) {
                const pageBlockPages = destination.droppableId === 'pageList'
                    ? survey.pageBlocks.flatMap((pb) => pb.pages.slice())
                    : []
                to.dropReorder(source.index + pageBlockPages.length, destination.index + pageBlockPages.length)
            } else if (source.droppableId.includes('pageblock') && draggableId.includes('surveyPage') && destination.droppableId.includes('pageList')) {
                this.reorderPagePageBlock(store, draggableId.split('_')[1], source, destination)
                const pageBlockId = source.droppableId.split('_')[1]
                const pageId = draggableId.split('_')[1]
                if (store.showInheritanceWarning) {
                    store.pendingParentChange = {
                        cb: () => {
                            survey.removePagePageBlock(store, pageBlockId, pageId)
                        },
                    }
                } else {
                    survey.removePagePageBlock(store, pageBlockId, pageId)
                }
            } else if (['qList', 'questionLibrary'].includes(source.droppableId)) {
                const question = from.dropGet(source.index)
                const parentQuestionId = question?.parentId?.toLowerCase()
                const parentHasMappings = store.surveyQuestionsIdsWithMapping?.get(parentQuestionId)
                if (parentHasMappings) {
                    this.surveyContainsParentWithMappings.show = true
                    this.surveyContainsParentWithMappings.questionTitle = parentHasMappings
                } else {
                    const parentId = question.parentId?.toLowerCase()
                    if (parentId
                            && !survey.pageQuestions.includes(parentId)) {
                        // parent question not in the survey
                        const { questionLibraryLists } = survey.questionLibrary.questionLibraryStore
                        const parentQuestion = getParentFromQlist(parentId, questionLibraryLists)
                        this.missingParentQuestion.show = true
                        if (parentQuestion) {
                            this.missingParentQuestion.msg = i18n.t(
                                'surveyBuilder.modal.missingParentModal.subtitle',
                                { questionTitle: parentQuestion.title },
                            )
                        } else this.missingParentQuestion.msg = i18n.t('surveyBuilder.modal.missingParentModal.subtitle.fallback')
                        return
                    }
                    const removedQuestion = from.dropRemove(source.index)
                    to.dropAdd(destination.index, removedQuestion)
                }
            } else {
                /**
                     * Validate Question move before performing if inheritance / skipLogic exists
                     * */
                if (from.getPagePriority() !== to.getPagePriority()
                    && from.getDropQuestion(source.index)?.question?.questionTypeCode === 'UV') {
                    return
                }
                const question = from.dropRemove(source.index, true)
                const originalPagePriority = from.getPagePriority()
                const targetPagePriority = to.getPagePriority()
                console.log(originalPagePriority, targetPagePriority)
                this.pendingMove = {
                    from,
                    to,
                    question,
                    sourceIndex: source.index,
                    destinationIndex: destination.index,
                }
                const warnings = affectedSkipLogicAfterPageQuestionMove(
                    survey,
                    this.pendingMove,
                    store,
                )

                if (originalPagePriority < targetPagePriority) {
                    // validate child inheritance
                    console.log('validate child inheritance')
                    const hasChildQuestions = question.hasInheringChildrenAffected(survey, targetPagePriority)
                    const nextQuestionIds = survey.pages.filter((page) => page.priority > targetPagePriority && page.pageType === 'ST')
                        .reduce((questionIds, page) => (
                            questionIds.concat(page.questions.map((pq) => pq.id))
                        ), [])
                    let isShowQuestionSource = false
                    if (!hasChildQuestions) {
                        const prevPageIds = survey.pages.filter((page) => page.priority <= targetPagePriority).map((page) => page.id)
                        isShowQuestionSource = survey.skipLogic.some((logic) => (
                            (
                                logic.action.kind === 'ShowQuestion'
                                        && !nextQuestionIds.includes(logic.action.pageQuestionId)
                                        && logic.triggerGroups.some((tg) => (
                                            tg.children.some((child) => (
                                                child.triggers.some((trigger) => (
                                                    trigger.condition.pageQuestionId === question.id
                                                ))
                                            ))
                                        ))
                            )
                                || (
                                    logic.action.kind === 'SkipToPage'
                                        && logic.triggerGroups[0]
                                        && logic.triggerGroups[0].children[0]
                                        && logic.triggerGroups[0].children[0].triggers[0]
                                        && logic.triggerGroups[0].children[0].triggers[0].condition.pageQuestionId === question.id
                                        && prevPageIds.includes(logic.action.pageId)
                                )
                        ))
                    }

                    if (hasChildQuestions || isShowQuestionSource) {
                        // show error as parentId gets removed
                        store.surveyUpdateWarnings = warnings
                        store.showInheritanceWarning = true
                    }
                } else {
                    if (question.parentId) {
                        /**  validate question inheritance */
                        console.log('validate question inheritance', typeof question)
                        const parentPageIndex = question.getParentPageIndex(survey)
                        console.log(parentPageIndex, targetPagePriority)
                        if (parentPageIndex >= targetPagePriority) {
                            // show error as parentId gets removed
                            store.surveyUpdateWarnings = warnings
                            store.showInheritanceWarning = true
                        }
                    }
                    if (!store.showInheritanceWarning) {
                        // question ids from same page, but before destination index
                        const samePage = survey.pages.filter(
                            (page) => page.priority === targetPagePriority && page.pageType === 'ST',
                        )[0]
                        const prevQuestionIdsInSamePage = samePage.questions
                            .filter((q) => q.priority <= destination.index)
                            .flatMap((pq) => pq.id)
                            // question ids from prev pages
                        let prevQuestionIds = survey.pages
                            .filter((page) => page.priority < targetPagePriority && page.pageType === 'ST')
                            .reduce((questionIds, page) => (
                                questionIds.concat(page.questions.map((pq) => pq.id))
                            ), [])
                        prevQuestionIds = prevQuestionIds.concat(prevQuestionIdsInSamePage)

                        const isShowQuestionTarget = survey.skipLogic.some((logic) => (
                            logic.action.kind === 'ShowQuestion'
                                    && logic.action.pageQuestionId === question.id
                                    && logic.triggerGroups.some((tg) => (
                                        tg.children.some((child) => (
                                            child.triggers.some((trigger) => (
                                                !prevQuestionIds.includes(trigger.condition.pageQuestionId)
                                            ))
                                        ))
                                    ))
                        ))
                        if (isShowQuestionTarget) {
                            store.surveyUpdateWarnings = warnings
                            store.showInheritanceWarning = true
                        }
                    }
                }
                Object.assign(this.pendingMove, to.dropMove(destination.index, question, from.getPageId(), true))
                /**
                     * JK Remember to uncomment
                     */
                if (!store.showInheritanceWarning) {
                    this.confirmMove()
                    // to.dropMove(destination.index, question, from.getPageId())
                }
            }
        } else if (destination.droppableId.includes('pageblock') && draggableId.includes('surveyPage')) {
            const pageBlockId = destination.droppableId.split('_')[1]
            const pageId = draggableId.split('_')[1]
            this.reorderPagePageBlock(store, pageId, source, destination)
            if (store.showInheritanceWarning) {
                if (source.droppableId.includes('pageblock')) {
                    const sourcePageBlockId = source.droppableId.split('_')[1]
                    store.pendingParentChange = {
                        cb: () => {
                            survey.addPageToPageBlock(store, pageBlockId, pageId, sourcePageBlockId)
                        },
                    }
                } else {
                    store.pendingParentChange = {
                        cb: () => {
                            survey.addPageToPageBlock(store, pageBlockId, pageId)
                        },
                    }
                }
            } else if (source.droppableId.includes('pageblock')) {
                const sourcePageBlockId = source.droppableId.split('_')[1]
                survey.addPageToPageBlock(store, pageBlockId, pageId, sourcePageBlockId)
            } else {
                survey.addPageToPageBlock(store, pageBlockId, pageId)
            }
        }
    }

    reorderPagePageBlock = (store, pageId, source, destination) => {
        const indexes = reorderPagePageBlockIndex(store, pageId, source, destination)
        store.dropTargets.pageList.dropReorder(indexes.oldIndex, indexes.newIndex)
    }

    removeInvalidInheritOptions = async () => {
        const { store } = this.props
        const invalidChildrenId = store.surveyUpdateWarnings.invalidInheritance
            .map((i) => i.childId)
        const childrenQuestions = store.survey.pages
            .filter((p) => p.pageType === 'ST')
            .flatMap((p) => p.questions)
            .filter((q) => invalidChildrenId.includes(q.id))

        // eslint-disable-next-line no-restricted-syntax
        for (const cq of childrenQuestions) {
            cq.parentId = undefined
            // eslint-disable-next-line no-await-in-loop
            await cq.update({
                ...cq.currentOptions,
                parentId: '00000000-0000-0000-0000-000000000000',
            })
        }
        store.surveyUpdateWarnings.invalidInheritance = []
    }

    confirmMove = async () => {
        const { store } = this.props
        console.log('confirmMove')
        if (this.pendingMove) {
            const {
                targetPage,
                body,
                questionBackup,
                endpoint,
            } = this.pendingMove
            const success = await targetPage.saveMove(store, body, questionBackup, endpoint)
            if (success) this.removeInvalidInheritOptions()
        }
        if (store.pendingPageMove) {
            const { body, endpoint } = store.pendingPageMove
            const success = await store.survey.saveMove(store, body, endpoint)
            if (success) this.removeInvalidInheritOptions()
        }
        if (store.pendingParentChange) {
            store.pendingParentChange.cb()
        }
        this.hideWarning()
    }

    cancelQuestionMove = () => {
        const { store } = this.props
        if (this.pendingMove) {
            const {
                from,
                to,
                question,
                sourceIndex,
                targetPage,
                questionBackup,
            } = this.pendingMove
            from.dropMove(sourceIndex, question, from.getPageId(), true)
            if (to.id === from.id) questionBackup.splice(sourceIndex, 0, question)
            targetPage.questions = questionBackup
        }
        if (store.pendingPageMove) {
            store.survey.movePage(store, store.pendingPageMove.to, store.pendingPageMove.from, true)
        }
        this.hideWarning()
    }

    hideWarning = () => {
        const { store } = this.props
        Reflect.deleteProperty(this, 'pendingMove')
        Reflect.deleteProperty(store, 'pendingPageMove')
        Reflect.deleteProperty(store, 'pendingParentChange')
        store.showInheritanceWarning = false
    }

    readNotification = () => {
        const { store, surveyId } = this.props
        store.http.post(`/survey/${surveyId}/notification`, store.surveyToken)
            .then((r) => {
                store.notificationRead = true
            })
            .catch((e) => {
                console.log(e)
                store.addNotification(null, 'Error hiding message', 'error')
            })
    }

    getNotificationMsg = () => {
        const { store } = this.props
        return store.useLatestUI
            ? 'views.survey.msg.switch_old'
            : 'views.survey.msg.switch_new'
    }

    getNotificationButton = () => {
        const { store } = this.props
        return store.useLatestUI
            ? 'views.survey.button.switch_old'
            : 'views.survey.button.switch_new'
    }

    updateLatestUI = () => {
        const { store } = this.props
        const { survey } = store
        fetch(`/survey/${survey.id}/latestui?uselatestui=${store.useLatestUI ? 0 : 1}`, {
            credentials: 'include',
            headers: {
                Accept: 'application/json',
            },
        })
            .then((response) => response.json())
            .then((response) => {
                console.log(response)
                if (response.error) {
                    store.addNotification(null, response.error, 'error')
                } else {
                    store.addNotification(null, 'UI selection updated', 'success')
                    location.reload()
                }
            })
            .catch((error) => {
                console.log(error)
                store.addNotification(null, error, 'error')
            })
    }

    getSkipLogicTitle = () => {
        const { store } = this.props
        const { skipLogicConfig } = store
        // s_alt_option_skip
        let title = 's_alt_page_skip'
        if (skipLogicConfig.type === 'question') {
            title = 's_alt_q_skip'
        } else if (skipLogicConfig.type === 'questionOption') {
            title = 's_alt_option_skip'
        }
        return i18n.t(title)
    }

    printSurvey = () => {
        const { store } = this.props
        const { survey } = store
        // store.gotoExternal(survey.getPrintLinkstore))
        window.open(`/survey/${survey.id}/print`, '_blank')
        // history.push(`/survey/${survey.id}/print`)
    }

    renderRapidSurveyBadge = () => (
        <div className="rapid-survey-badge">
            <div className="icons-wrapper">
                <i className="fa-light fa-align-right" />
                <i className="fa-regular fa-clipboard-list" />
            </div>
            <p>{i18n.t('surveyBuilder.rapidSurvey.badge.title')}</p>
        </div>
    )

    render() {
        const { store, history, match } = this.props
        const { survey, tokenData } = store
        const { standardPages, exitPages, showBranchBanner } = survey
        const isRapidSurvey = R.pathOr(false, ['metadata', 'isRapidSurvey'], survey)

        if (survey.notFound) {
            <div className="notFound">
                <i className="fa fa-ban" />
                {' '}
                {i18n.t('msg_survey_not_found')}
            </div>
        }

        const guideAccordionContent = (
            <Fragment>
                <p>{i18n.t('s_builder_info_text')}</p>

                <div className="builder-question-mock">
                    <MockQuestion color="red" text={i18n.t('s_explori_questions')} />

                    <MockQuestion color="purple" text={i18n.t('s_company_questions')} style={{ borderTop: '1px solid grey' }} />

                    <MockQuestion color="green" text={i18n.t('s_event_questions')} style={{ borderTop: '1px solid grey' }} />

                    <div className="builder-question-mock-gradient" />
                </div>
            </Fragment>
        )

        console.log('check', this.surveyLoading, this.questionLibraryLoading, this.isReady)
        const showPublishBanner = store.isTemplate && process.env.NEW_TEMPLATING && process.env.USE_NEW_HEADER_UI
        return (
            <div>
                {!this.isReady && <AppLoading />}
                <div>
                    <div className="surveyBuilder" style={{ padding: `${showBranchBanner ? 114 : 54}px 0px 0px 0px` }}>
                        {showPublishBanner && <PublishBanner store={store} />}
                        {!store.showTranslate && (
                            <div className="builder-content-wrapper">
                                <DragDropContext onDragEnd={this.onDragEnd} onBeforeCapture={this.handleDragStart}>
                                    <div style={{ width: '100%', display: 'flex', gap: 24 }}>
                                        <div className={`builder-left-content-wrapper ${process.env.USE_NEW_HEADER_UI ? 'new-styles' : ''}`}>
                                            {process.env.USE_NEW_HEADER_UI
                                                && (
                                                    <>
                                                        <SurveyOverview
                                                            store={store}
                                                            openDownloadModal={this.openDownloadModal}
                                                            openSurveyQuotaModal={this.openSurveyQuotaModal}
                                                            renderRapidSurveyBadge={this.renderRapidSurveyBadge}
                                                            changeLanguage={this.changeLanguage}
                                                        />
                                                        <br />
                                                    </>
                                                )}

                                            <QuestionLibrary
                                                store={store}
                                                history={history}
                                                match={match}
                                                screen="surveyBuilder"
                                                survey={survey}
                                                allowInherit
                                                onLoad={this.setQuestionLibraryLoaded}
                                                guideAccordionContent={guideAccordionContent}
                                                show={this.isReady}
                                            />
                                        </div>

                                        {this.isReady
                                            && (
                                                <div className={`builder-right-content-wrapper ${process.env.USE_NEW_HEADER_UI ? 'new-styles' : ''}`}>
                                                    {process.env.USE_NEW_HEADER_UI
                                                        ? null
                                                        : (
                                                            <Panel cssClass="builder-right-floating-panel">
                                                                <div>
                                                                    <div className="survey-title-container">
                                                                        <h3>{survey.title}</h3>
                                                                        {isRapidSurvey && this.renderRapidSurveyBadge()}
                                                                    </div>
                                                                    <br />

                                                                    <hr />
                                                                    {isRapidSurvey && (
                                                                        <>
                                                                            <br />
                                                                            <RapidSurveyAccordion store={store} />
                                                                        </>
                                                                    )}
                                                                    <br />

                                                                    <div className="builder-right-floating-panel-bottom-content">
                                                                        <div className="builder-right-floating-panel-actions">
                                                                            <Button
                                                                                cssClass="tertiary regular"
                                                                                onClick={this.openDownloadModal}
                                                                                label={i18n.t('s_export_options')}
                                                                                icon="fal fa-folder-arrow-down"
                                                                            />
                                                                            {process.env.USE_NEW_HEADER_UI ? null : (
                                                                                <Button
                                                                                    cssClass="tertiary regular"
                                                                                    onClick={this.printSurvey}
                                                                                    label={i18n.t('s_print_2')}
                                                                                    icon="fal fa-print"
                                                                                />
                                                                            )}
                                                                            {process.env.TRANSLATIONS && (
                                                                                <Button
                                                                                    cssClass="tertiary regular"
                                                                                    onClick={() => { store.showTranslate = true }}
                                                                                    label={i18n.t('translation.title')}
                                                                                    icon="fal fa-print"
                                                                                />
                                                                            )}

                                                                            {survey.metadata.allowQuotas && (
                                                                                <Button
                                                                                    cssClass="tertiary regular"
                                                                                    icon="fal fa-plus"
                                                                                    label={i18n.t('s_add_overallsurveyquota')}
                                                                                    title="Add overall quota"
                                                                                    onClick={this.openSurveyQuotaModal}
                                                                                />
                                                                            )}
                                                                        </div>

                                                                        <div className="builder-right-floating-panel-info-container">
                                                                            <div className="builder-right-floating-panel-info-dropdown">
                                                                                <Select
                                                                                    options={survey.metadata.locales.map((locale) => ({
                                                                                        value: locale,
                                                                                        label: '',
                                                                                        src: `${process.env.CDN_URL}/includes/images/flags/${locale}.png`,
                                                                                    }))}
                                                                                    defaultValue={store.surveyLocale}
                                                                                    onBlur={this.changeLanguage}
                                                                                />
                                                                            </div>

                                                                            <p>
                                                                                {`Pages: ${standardPages.length}`}
                                                                            </p>

                                                                            <p>
                                                                                {`${i18n.t('s_count_questions')}: ${survey.num_questions}`}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <AdminBox store={store} survey={survey} />
                                                            </Panel>
                                                        )}

                                                    {survey.closed
                                                            && <ClosedBox survey={survey} />}

                                                    <PageList store={store} history={this.props.history} pageDragId={this.pageDragId} />

                                                    <PageBlockHide store={store} />
                                                    <PageBlockDelete store={store} />

                                                    <Panel>
                                                        <div className="builder-bottom-panel">
                                                            <Button
                                                                cssClass="regular primary"
                                                                onClick={this.addScreeningExitPage}
                                                                label={i18n.t('s_add_exitpage')}
                                                                icon="fal fa-right-from-bracket"
                                                                disabled={survey.closed}
                                                            />

                                                            <Button
                                                                cssClass="regular primary"
                                                                onClick={this.addCompletionPage}
                                                                label={i18n.t('s_add_confpage')}
                                                                icon="fal fa-circle-check"
                                                                disabled={survey.closed}
                                                            />

                                                            {survey.metadata.allowQuotas && (
                                                                <Button
                                                                    cssClass="quota"
                                                                    onClick={this.addQuotaPage}
                                                                    style={{ marginLeft: '12px' }}
                                                                    label={i18n.t('s_add_quotapage')}
                                                                    icon="fal fa-plus"
                                                                    disabled={survey.closed}
                                                                />
                                                            )}
                                                        </div>
                                                    </Panel>
                                                </div>
                                            )}
                                    </div>
                                </DragDropContext>
                            </div>
                        )}

                        {store.showTranslate && (
                            <Translate
                                survey={survey}
                                store={store}
                                locales={store.localeOptions.filter(({ value }) => survey.metadata.locales.includes(value))}
                                defaultLocale={survey.metadata.defaultLocale}
                            />
                        )}

                        {store.showQuestionEditor && (
                            <QuestionBuilder store={store} />
                        )}
                        {/* {store.showQuestionEditor &&
                            <QuestionEditor
                                store={store}
                                availableLocales={survey.metadata.locales}
                                defaultLocale={store.surveyLocale}
                            />
                        } */}
                        <QuestionPipe
                            show={store.showQuestionPipe}
                            store={store}
                            availableLocales={survey.metadata.locales}
                            defaultLocale={store.surveyLocale}
                        />
                        <InheritanceWarningModal
                            store={store}
                            onClose={this.cancelQuestionMove}
                            confirm={this.confirmMove}
                        />

                        <ExploriEditWarningModal store={store} />

                        <AddChartModal store={store} />

                        <AddAiQuestion store={store} />

                        <RemoveAiQuestion store={store} />

                        <QuestionDelete store={store} />

                        <QuestionDisable store={store} />

                        <PageDelete store={store} />

                        <PageDisable store={store} />

                        <SurveyQuotaModal store={store} that={this} />

                        <DownloadModal store={store} pageType={store.showTranslate ? 'translate' : 'survey'} />

                        <PageTemplate store={store} />

                        <PageSkipLogicPreview store={store} />

                        {!survey.notFound && !survey.closed && !survey.loading && tokenData && !survey.loadingQuestions && store.survey.questionLibrary
                            ? <MandatoryPopup store={store} isOtherModalOpened={this.showNewRapidSurveyModal} />
                            : null}

                        <NewRapidSurveyModal
                            onClose={() => this.setShowNewRapidSurveyModal(false)}
                            show={this.showNewRapidSurveyModal}
                        />

                        <SkipLogicModal
                            store={store}
                            hide={this.hideSkipLogicModal}
                            type={this.skipLogicModalType}
                        />

                        <UnsavedSkipLogicModal store={store} />

                        <ConfirmationModal
                            show={this.surveyContainsParentWithMappings.show}
                            onClose={() => { this.surveyContainsParentWithMappings.show = false }}
                            title={i18n.t('surveyBuilder.modal.surveyContainsParentWithMappings.title')}
                            description={i18n.t(
                                'surveyBuilder.modal.surveyContainsParentWithMappings.desc',
                                { questionTitle: this.surveyContainsParentWithMappings.questionTitle },
                            )}
                        />

                        <ConfirmationModal
                            show={this.missingParentQuestion.show}
                            onClose={() => { this.missingParentQuestion.show = false }}
                            title={i18n.t('surveyBuilder.modal.missingParentModal.title')}
                            description={this.missingParentQuestion.msg}
                        />

                        {this.props.showCertification && process.env.SHOW_CERTIFICATION
                            ? <CertificationSidebar store={store} history={this.props.history} />
                            : null }
                    </div>
                </div>
            </div>
        )
    }
}
